import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface CourtCardProps {
  id: string;
  name: string;
  image: string;
  surface: string;
  type: 'Indoor' | 'Outdoor';
  availability: string;
  availableSlots: number;
  price: number;
  priceUC: number;
  isFavorite?: boolean;
}
export function CourtCard({
  id,
  name,
  image,
  surface,
  type,
  availability,
  availableSlots,
  price,
  priceUC,
  isFavorite = false
}: CourtCardProps) {
  const navigate = useNavigate();
  const [favorite, setFavorite] = useState(isFavorite);
  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setFavorite(!favorite);
  };
  const isAvailable = availableSlots > 0;
  return <button onClick={() => navigate(`/court/${id}`)} className="w-full bg-white rounded-xl shadow-md overflow-hidden active:scale-98 transition-transform text-left" data-id="element-70">
      {/* Court Image */}
      <div className="relative h-40 overflow-hidden" data-id="element-71">
        <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-72" />
        {/* Logo Overlay */}
        <div className="absolute top-2 right-2 bg-white/90 rounded-lg px-2 py-1" data-id="element-73">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYmeFB35HhojatJVz8XpFb/PickleballBruneiLogoC.webp" alt="Pickleball Brunei" className="h-4 object-contain" data-id="element-74" />
        </div>
        {/* Favorite Button */}
        <button onClick={handleFavoriteClick} className="absolute top-2 left-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors" data-id="element-75">
          <HeartIcon className={`w-5 h-5 ${favorite ? 'fill-[#E53935] text-[#E53935]' : 'text-gray-600'}`} data-id="element-76" />
        </button>
      </div>

      {/* Court Details */}
      <div className="p-4" data-id="element-77">
        <h3 className="text-lg font-bold text-[#1f5070] mb-1" data-id="element-78">{name}</h3>
        <p className="text-sm text-[#666666] mb-2" data-id="element-79">
          {surface} • {type}
        </p>

        {/* Availability */}
        <div className="flex items-center gap-2 mb-3" data-id="element-80">
          {isAvailable ? <>
              <div className="w-2 h-2 bg-[#43A047] rounded-full" data-id="element-81"></div>
              <span className="text-sm text-[#43A047] font-medium" data-id="element-82">
                {availableSlots} {availableSlots === 1 ? 'slot' : 'slots'} today
              </span>
            </> : <>
              <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-83"></div>
              <span className="text-sm text-gray-400 font-medium" data-id="element-84">
                Fully booked
              </span>
            </>}
        </div>

        {/* Price */}
        <div className={`text-base font-bold ${isAvailable ? 'text-[#3dc7e3]' : 'text-gray-400'}`} data-id="element-85">
          {priceUC} UC or ${price}/hour
        </div>
      </div>
    </button>;
}